const data = {
  h1Tag: "Health Communities by Shyft",
  headerCTAText: "Join the community",
  heading:
    "You have school friends, you have work friends…. But do you have health(y) friends?",
  subheading:
    "A peer group makes everything easy, so why not be part of a group that motivates, inspires and helps you achieve your health goals all while having fun!",
  welcomePrefix: "INTRODUCING",
  welcomeHeading: "Communities",
  welcomeSubheading: "by Shyft",
  howItWorksTitle: "How it works",
  howItWorks: [
    {
      icon: "icon-community-people",
      title:
        "After understanding your lifestyle and interests, we place you in a community of like minded people -people of a similar age group, demographic, interests and a similar health journey as you",
    },
    {
      icon: "icon-community-hand",
      title:
        "As part of the community, get access to expert insights, guidance from health professionals, motivation & support from the group, curated workouts, challenges, meetups and build lasting connections!",
    },
  ],
  glow1Url:
    "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-05/whatsapp-community-glow-1-919b59ab27e045939f739404f758795e.png",
  glow2Url:
    "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-05/whatsapp-community-glow-2-129a3d6861344905a106a1d426d599bc.png",
  formData: {
    src: "https://tally.so/embed/wvr20v?alignLeft=1&transparentBackground=1&dynamicHeight=1&hideTitle=1",
    title: "What's Your Fitness personality?",
  },
};

export default data;
